import { TOGGLE_PAGE_FLAG } from '../actions/index';

export default function(state = {}, action) {
  switch (action.type) {
  case TOGGLE_PAGE_FLAG: {
    const pages = { ...state };
    delete pages[action.page];
    return pages;
  }
  default:
    return state;
  }
}
